import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../Header/header";
import Fotter from "../Fotter/fotter";
import { toast } from "react-toastify";
import API_URL from "../../config";


function ForgotPassword() {
    const [step, setStep] = useState(1); // 1: Email, 2: Reset (OTP + New Password)
    const [form, setForm] = useState({ email: "", otp: "", newPassword: "" });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();

    const handleSendOTP = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {
            const res = await fetch(`${API_URL}/api/auth/forgot-password`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email: form.email }),
            });
            const data = await res.json();
            if (res.ok) {
                toast.success(data.msg);
                setStep(2);
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            toast.error("Failed to send reset OTP");
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleResetPassword = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {
            const res = await fetch(`${API_URL}/api/auth/reset-password`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(form),
            });
            const data = await res.json();
            if (res.ok) {
                toast.success("Password reset successful!");
                navigate("/login");
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            toast.error("Failed to reset password");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div>
            <Header />
            <div className="min-h-screen flex items-center justify-center bg-sky-50 p-6">
                <div className="w-full max-w-5xl flex flex-col md:flex-row bg-white rounded-xl shadow-md overflow-hidden">
                    {/* Left panel with image (similar to Login) */}
                    <div className="w-full md:w-1/2 relative">
                        <img
                            src="https://images.unsplash.com/photo-1502602898657-3e91760cbb34?q=80&w=2073&auto=format&fit=crop"
                            alt="Travel inspiration"
                            className="h-full w-full object-cover"
                        />
                        <div className="absolute inset-0 bg-sky-900/40 flex flex-col justify-center p-10 text-white">
                            <h2 className="text-3xl font-bold mb-3">Recover Account</h2>
                            <p className="text-lg text-sky-100 mb-8">
                                Don't worry, we'll help you get back to your journey.
                            </p>
                            <div className="space-y-5">
                                <div className="flex items-center space-x-3">
                                    <span className="text-2xl">🛡️</span>
                                    <span>Secure reset process</span>
                                </div>
                                <div className="flex items-center space-x-3">
                                    <span className="text-2xl">⚡</span>
                                    <span>Quick OTP verification</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right panel (Forms) */}
                    <div className="w-full md:w-1/2 p-10 flex items-center">
                        <div className="w-full">
                            {step === 1 ? (
                                <form onSubmit={handleSendOTP} className="space-y-6">
                                    <h2 className="text-2xl font-bold text-amber-600">Forgot Password</h2>
                                    <p className="text-sm text-gray-500">Enter your email to receive a secure reset code.</p>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700">Email Address</label>
                                        <input
                                            type="email"
                                            placeholder="Enter your registered email"
                                            className="w-full mt-1 px-4 py-2 border border-sky-200 rounded-lg focus:ring-2 focus:ring-sky-500 outline-none"
                                            value={form.email}
                                            onChange={(e) => setForm({ ...form, email: e.target.value })}
                                            required
                                        />
                                    </div>
                                    <button
                                        type="submit"
                                        disabled={isSubmitting}
                                        className="w-full py-3 rounded-lg text-white font-semibold bg-gradient-to-r from-sky-500 to-teal-500 hover:from-sky-600 hover:to-teal-600 transition duration-200"
                                    >
                                        {isSubmitting ? "Sening Code..." : "Send Reset Code →"}
                                    </button>
                                </form>
                            ) : (
                                <form onSubmit={handleResetPassword} className="space-y-6">
                                    <h2 className="text-2xl font-bold text-amber-600">Reset Password</h2>
                                    <p className="text-sm text-gray-500">Enter the code sent to {form.email}</p>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700">6-Digit Code</label>
                                        <input
                                            type="text"
                                            maxLength="6"
                                            placeholder="000000"
                                            className="w-full mt-1 px-4 py-2 border border-sky-200 rounded-lg focus:ring-2 focus:ring-sky-500 text-center text-xl tracking-widest outline-none"
                                            value={form.otp}
                                            onChange={(e) => setForm({ ...form, otp: e.target.value })}
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700">New Password</label>
                                        <input
                                            type="password"
                                            placeholder="Minimum 6 characters"
                                            className="w-full mt-1 px-4 py-2 border border-sky-200 rounded-lg focus:ring-2 focus:ring-sky-500 outline-none"
                                            value={form.newPassword}
                                            onChange={(e) => setForm({ ...form, newPassword: e.target.value })}
                                            required
                                        />
                                    </div>
                                    <button
                                        type="submit"
                                        disabled={isSubmitting}
                                        className="w-full py-3 rounded-lg text-white font-semibold bg-gradient-to-r from-teal-500 to-emerald-500 hover:opacity-90 transition duration-200"
                                    >
                                        {isSubmitting ? "Resetting..." : "Reset Password →"}
                                    </button>
                                    <button type="button" onClick={() => setStep(1)} className="text-sm text-gray-500 hover:underline w-full text-center">
                                        Back to email
                                    </button>
                                </form>
                            )}
                            <div className="mt-8 pt-6 border-t border-gray-100 text-center">
                                <Link to="/login" className="text-sm text-sky-600 hover:underline font-medium">Back to Login</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Fotter />
        </div>
    );
}

export default ForgotPassword;
